// extracted by mini-css-extract-plugin
module.exports = {"inlintInput":"InlineInput_inlintInput__2-2ep","green":"InlineInput_green__2QKkq","orange":"InlineInput_orange__10byR"};